import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  Toast,
  AlertController
} from "ionic-angular";
import { Block } from "../../models/block.interface";
import QRCode from "qrcode";
import { ToastProvider } from "../../providers/toast/toast";
import { EmailComposer } from "@ionic-native/email-composer";
import { Screenshot } from "@ionic-native/screenshot";

@Component({
  selector: "page-generate",
  templateUrl: "generate.html"
})
export class GeneratePage {
  createdCode: string = "";
  block: Block;
  code: string = "";
  generated = "";
  barcode: string = "";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toast: ToastProvider,
    public alertCtrl: AlertController,
    private emailComposer: EmailComposer,
    public screenshot: Screenshot
  ) {
    this.block = this.navParams.get("block");
    this.barcode = this.navParams.get("barcode");
    this.code = this.navParams.get("code");
    this.createCode();
  }

  ionViewDidEnter() {
    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title:
        "Print this page and include it with your item or email to the buyer so it can be scanned.",
      buttons: ["Got it"]
    });
    alert.present();
  }

  displayQrCode() {
    return this.generated !== "";
  }

  createCode() {
    this.createdCode = this.barcode;
  }

  save() {}

  email() {
    this.screenshot
      .save("jpg", 100, "NativeChain-" + this.barcode + ".jpg")
      .then((res: any) => {
        if (this.code == "") {
          let email = {
            subject: "NativeChain Codes for Item #" + this.block.count,
            attachments: [res.filePath],
            body:
              "Here are the codes for my item listed on the NativeChain Platform. <br>The QR code is <b>" +
              this.barcode +
              "</b>. <br><br>NativeChain on <b>iOS</b>: https://itunes.apple.com/us/app/NativeChain/id1387302520?ls=1&mt=8 <br><br>NativeChain on <b>Android</b>: https://play.google.com/store/apps/details?id=com.nativechain.app"
          };
          this.emailComposer.open(email);
        } else if (this.code != "") {
          let email = {
            subject: "NativeChain Codes for Item #" + this.block.count,
            attachments: [res.filePath],
            body:
              "Here are the codes for my item listed on the NativeChain Platform. <br>The QR code is <b>" +
              this.barcode +
              "</b>. The unique code is <b>" +
              this.code +
              "</b>. <br><br>NativeChain on <b>iOS</b>: https://itunes.apple.com/us/app/NativeChain/id1387302520?ls=1&mt=8 <br><br>NativeChain on <b>Android</b>: https://play.google.com/store/apps/details?id=com.nativechain.app"
          };
          this.emailComposer.open(email);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/generate/generate.ts